import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'

import {
  Botao,
  Breadcrumb,
  Cabecalho,
  ErroLayoutContainer,
  Filtro,
  InputUnform,
  SelectAsyncUnform,
  SelectUnform,
  DataInputUnform
} from 'src/componentes'
import { formatarCpf } from 'src/componentes/funcoes/cpf'
import {
  Tabela,
  TabelaDados,
  TabelaRef,
  TabelaResposta
} from 'src/componentes/tabela'
import { SelectOpcaoCursos } from 'src/dto'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'
import { Api } from 'src/servicos'
import { RequisitarListaTurmasPorTexto } from 'src/servicos/api'
import { AlunoSituacao, TipoOrdenacao } from 'src/tipos'

import {
  OPCOES_MODALIDADE,
  OPCOES_SITUACAO_FINANCEIRA,
  OPCOES_SITUACAO_UPLOAD
} from './opcoes'
import { Form, Container, Campo, Dados, ContainerExportar } from './styles'
import { DadosPesquisa } from './tipos'

export const PaginaDocumentosAluno: React.FC = () => {
  const tabelaRef = useRef<TabelaRef>()

  const [dadosPesquisa, definirDadosPesquisa] = useState<DadosPesquisa>(null)
  const [paginas, definirPaginas] = useState<number>(null)
  const [carregando, definirCarregando] = useState(false)

  const acaoPesquisa = (dados: DadosPesquisa) => {
    if (dados !== null && paginas !== 1) {
      definirPaginas(1)
    }

    definirDadosPesquisa(dados)
  }
  const obterCursos = async (nome: string): Promise<SelectOpcaoCursos[]> => {
    const result = await Api.RequisitarListaCursoOutros(nome)
    return result.map(x => ({ id: x.id, texto: x.nome }))
  }

  const obterDados = async (
    numeroPaginas: number,
    quantidadePorPagina: number,
    chaveOrdenacao?: string,
    ordem?: TipoOrdenacao
  ): Promise<TabelaResposta | null> => {
    if (paginas !== null) {
      numeroPaginas = paginas
    }
    const dados = await Api.ObterRelatorioDocumentosAluno(
      {
        nomeAluno: dadosPesquisa?.nomeAluno,
        modalidades: dadosPesquisa?.modalidade,
        cursosId: dadosPesquisa?.curso,
        turmasId: dadosPesquisa?.turma,
        situacoes: dadosPesquisa?.situacaoUpload,
        situacoesFinanceiras: dadosPesquisa?.situacoesFinanceiras,
        dataEnvio: dadosPesquisa?.dataEnvio,
        dataConferencia: dadosPesquisa?.dataConferencia
      },
      numeroPaginas,
      quantidadePorPagina,
      chaveOrdenacao,
      ordem
    )

    if (!dados) return null

    definirPaginas(null)

    return {
      Dados: dados.registros,
      Paginacao: {
        Pagina:
          dados.opcoesPaginacao.totalPaginas < dados.opcoesPaginacao.pagina
            ? 1
            : dados.opcoesPaginacao.pagina,
        TotalRegistros: dados.opcoesPaginacao.totalRegistros
      }
    } as TabelaResposta
  }

  const downloadDados = async () => {
    try {
      definirCarregando(true)
      const download = await Api.ObterDownloadRelatorioDocumentosAluno({
        nomeAluno: dadosPesquisa?.nomeAluno,
        modalidades: dadosPesquisa?.modalidade,
        cursosId: dadosPesquisa?.curso,
        turmasId: dadosPesquisa?.turma,
        situacoes: dadosPesquisa?.situacaoUpload,
        situacoesFinanceiras: dadosPesquisa?.situacoesFinanceiras,
        dataEnvio: dadosPesquisa?.dataEnvio,
        dataConferencia: dadosPesquisa?.dataConferencia
      })

      if (download === false) {
        toast('Nenhum resultado encontrado com filtro atual!', {
          type: 'info'
        })
      }
    } catch (error) {
      toast('Erro ao efetuar download do arquivo!', { type: 'error' })
    } finally {
      definirCarregando(false)
    }
  }

  useEffect(() => {
    if (dadosPesquisa === null) return
    tabelaRef.current.CarregarDados()
  }, [dadosPesquisa])

  return (
    <>
      <Cabecalho>
        <Breadcrumb
          titulo="Documentos enviados pelo Aluno"
          atalhos={[
            {
              texto: 'Relatórios Acadêmicos'
            },
            {
              texto: 'Documentos enviados pelo Aluno'
            }
          ]}
        />
      </Cabecalho>
      <Filtro>
        <Form
          dadosIniciais={{
            situacao: AlunoSituacao[AlunoSituacao.Todas]
          }}
          acaoSucesso={acaoPesquisa}
        >
          <Container>
            <Campo mr>
              <InputUnform
                type="text"
                name="nomeAluno"
                label="Nome"
                maxLength={200}
              />
            </Campo>
            <Campo mr style={{ marginBottom: '25px' }}>
              <SelectAsyncUnform
                id="slct_curso"
                name="curso"
                label="Curso"
                multiplo
                buscarPorTexto={obterCursos}
                buscarPorId={obterCursos}
              />
            </Campo>

            <Campo style={{ marginBottom: '25px' }}>
              <SelectAsyncUnform
                id="slct_turma"
                name="turma"
                label="Turma"
                multiplo
                buscarPorTexto={RequisitarListaTurmasPorTexto}
                buscarPorId={RequisitarListaTurmasPorTexto}
              />
            </Campo>
          </Container>
          <Container>
            <Campo mr>
              <SelectUnform
                id="slct_modalidade"
                name="modalidade"
                label="Modalidade"
                placeholder="Selecione"
                multiplo
                opcoes={OPCOES_MODALIDADE}
              />
            </Campo>
            <Campo mr>
              <SelectUnform
                id="slct_situacao"
                name="situacaoUpload"
                label="Situação"
                placeholder="Selecione"
                multiplo
                opcoes={OPCOES_SITUACAO_UPLOAD}
              />
            </Campo>
            <Campo>
              <SelectUnform
                id="slct_situacao_financeira"
                name="situacoesFinanceiras"
                label="Situação Matricula"
                iconeFechar
                multiplo
                opcoes={OPCOES_SITUACAO_FINANCEIRA}
              />
            </Campo>
          </Container>
          <Container>
            <Campo mr>
              <DataInputUnform name="dataEnvio" label="Data Envio" />
            </Campo>
            <Campo mr>
              <DataInputUnform
                name="dataConferencia"
                label="Data Conferência"
              />
            </Campo>
            <Campo></Campo>
          </Container>
          <Botao
            type="submit"
            id="btn-aplicar-filtro"
            texto="Aplicar filtro"
            tema="Link"
          />
        </Form>
      </Filtro>
      <ContainerExportar>
        <Botao
          type="button"
          id="btn-download-relatorio"
          texto="Exportar"
          onClick={downloadDados}
          carregando={carregando}
        />
      </ContainerExportar>
      <Dados>
        <Tabela
          ref={tabelaRef}
          Colunas={[
            {
              Chave: 'nomeAluno',
              ComOrdenacao: true,
              Renderizar: (linha: TabelaDados) => (
                <span>{linha.nomeAluno}</span>
              ),
              RenderizarCabecalho: () => <div style={{ width: 200 }}>Nome</div>
            },
            {
              Chave: 'emailAluno',
              ComOrdenacao: true,
              RenderizarCabecalho: () => (
                <div style={{ width: 200 }}>E-mail</div>
              )
            },
            {
              Chave: 'cpf',
              ComOrdenacao: true,
              Renderizar: (linha: TabelaDados) => (
                <span>{formatarCpf(linha.cpf)}</span>
              ),
              RenderizarCabecalho: () => <div style={{ width: 100 }}>CPF</div>
            },
            {
              Chave: 'nacionalidade',
              ComOrdenacao: true,
              RenderizarCabecalho: () => (
                <div style={{ width: 120 }}>Nacionalidade</div>
              )
            },
            {
              Chave: 'tipoArquivo',
              ComOrdenacao: true,
              RenderizarCabecalho: () => (
                <div style={{ width: 100 }}>Tipo Arquivo</div>
              )
            },
            {
              Chave: 'nomeArquivo',
              ComOrdenacao: true,
              RenderizarCabecalho: () => (
                <div style={{ width: 150 }}>Nome Arquivo</div>
              )
            },
            {
              Chave: 'dataEnvio',
              ComOrdenacao: true,
              Renderizar: (linha: TabelaDados) => (
                <span>{formatadores.dataLocaleString(linha.dataEnvio)}</span>
              ),
              RenderizarCabecalho: () => (
                <div style={{ width: 90 }}>Data Envio</div>
              )
            },
            {
              Chave: 'dataConferencia',
              ComOrdenacao: true,
              Renderizar: (linha: TabelaDados) => (
                <span>
                  {formatadores.dataLocaleString(linha.dataConferencia)}
                </span>
              ),
              RenderizarCabecalho: () => (
                <div style={{ width: 90 }}>Data Conferência</div>
              )
            },
            {
              Chave: 'turmas',
              ComOrdenacao: true,
              RenderizarCabecalho: () => (
                <div style={{ width: 250 }}>Turmas</div>
              )
            },
            {
              Chave: 'situacaoMatriculas',
              ComOrdenacao: true,
              RenderizarCabecalho: () => (
                <div style={{ width: 250 }}>Situação Matricula</div>
              )
            },
            {
              Chave: 'motivoRejeicao',
              ComOrdenacao: true,
              RenderizarCabecalho: () => (
                <div style={{ width: 100 }}>Motivo Rejeição</div>
              )
            },
            {
              Chave: 'situacaoDocumento',
              ComOrdenacao: true,
              RenderizarCabecalho: () => (
                <div style={{ width: 120 }}>Situação do Documento</div>
              )
            },
            {
              Chave: 'conferidoPor',
              ComOrdenacao: true,
              RenderizarCabecalho: () => (
                <div style={{ width: 200 }}>Conferido Por</div>
              )
            }
          ]}
          ObterDados={obterDados}
          ComPaginacao
        />
      </Dados>
    </>
  )
}

export default (): JSX.Element => (
  <ErroLayoutContainer.Provider>
    <PaginaDocumentosAluno />
  </ErroLayoutContainer.Provider>
)
